import { useState } from 'react'
import { BetaFeedbackModal } from '@/shell/BetaFeedbackModal'
import { Tooltip } from '@/shared/components/Tooltip'
import { useSidebar } from '@/context/SidebarContext'
import { styles } from '@/shell/layout.styles'
import { NAV_ICONS } from '@/shell/nav/navIcons'

export function BetaFeedbackCard() {
  const { collapsed } = useSidebar()
  const [show, setShow] = useState(false)
  if (collapsed) {
    return (
      <>
        {show && <BetaFeedbackModal onClose={() => setShow(false)} />}
        <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0 14px', flexShrink: 0 }}>
          <Tooltip text="Spotted a bug? Send feedback" placement="right">
            <button style={styles.themeToggle} aria-label="Send feedback" onClick={() => setShow(true)}>
              {NAV_ICONS.feedback}
            </button>
          </Tooltip>
        </div>
      </>
    )
  }
  return (
    <div style={styles.feedbackCard}>
      {show && <BetaFeedbackModal onClose={() => setShow(false)} />}
      <div style={styles.feedbackCardTitle}>Spotted a bug?</div>
      <div style={styles.feedbackCardText}>Tell us what's broken, what's missing or what you'd like to see.</div>
      <button className="btn btn-primary btn-sm" style={{ width: '100%' }} onClick={() => setShow(true)}>
        Send feedback
      </button>
    </div>
  )
}
